import { PROVIDER_PORTAL_MAIN_COLUMN_CLASS } from "./util/providerPortalMainColumn";

const Terms = () => {
  return (
    <div className={PROVIDER_PORTAL_MAIN_COLUMN_CLASS} id="terms_page">
      <div className="about_heading">Terms of Service</div>
      <div className="terms_section">
        <div className="terms_heading">Copyright and Trademark Notice</div>
        <div className="terms_text">
          Unless otherwise specified, all materials appearing on this site;
          including text, site design, logos, graphics, icons, and images, as
          well as the selection, assembly and arrangement thereof, are the sole
          property of Verse Medical, Inc., Copyright ©, ALL RIGHTS RESERVED.
          You may use the content of this site only for the purpose of shopping
          in this store or placing an order and for no other purpose. No
          materials from this site may be copied, reproduced, modified,
          republished, uploaded, posted, transmitted or distributed in any form
          or by any means without our prior written permission. All rights not
          expressly granted herein are reserved. Any unauthorized use of the
          materials appearing on this site may violate copyright, trademark and
          other applicable laws and could result in criminal or civil penalties.
        </div>
      </div>

      <div className="terms_section">
        <div className="terms_heading">Credit Cards</div>
        <div className="terms_text">
          We accept credit cards as a form of payment. There is no surcharge for
          using your credit card to make purchases. Please be sure to provide
          your exact billing address and telephone number (i.e. the address and
          phone number your credit card bank has on file for you). Incorrect
          information will cause a delay in processing your order.
        </div>
      </div>

      <div className="terms_section">
        <div className="terms_heading">Links</div>
        <div className="terms_text">
          This site may contain links to other sites on the Internet that are
          owned and operated by third parties. You acknowledge that is not
          responsible for the operation of, or content located on or throughout
          any such site.
        </div>
      </div>

      <div className="terms_section">
        <div className="terms_heading">Multiple Product Orders</div>
        <div className="terms_text">
          For multiple product orders, we will make every attempt to ship all
          items contained in that order at the same time. Products that are
          unavailable at the time of shipping will be shipped as they become
          available, unless you inform us otherwise. You will only be charged
          for products contained in a given shipment, plus any applicable
          shipping charges. You will only be charged for shipping at the rate
          quoted to you on your purchase receipt. The entirety of this shipping
          charge will be applied to the first product(s) shipped on a multiple
          shipment order.
        </div>
      </div>

      <div className="terms_section">
        <div className="terms_heading">Order Acceptance Policy</div>
        <div className="terms_text">
          Your receipt of an electronic or other form of order confirmation does
          not signify our acceptance of your order, nor does it constitute
          confirmation of our offer to sell. reserves the right at any time
          after receipt of your order to accept or decline your order for any
          reason. All declined orders will be refunded in FULL. All orders will
          be shipped only after a mandatory verification of prescription entered
          with respective MD or OD by Jet Lenses, unless a copy of of a valid
          prescription is uploaded by the customer. All prescription
          verifications are subject to a hold of eight business hours till MD/OD
          sends a response to our request.
        </div>
      </div>

      <div className="terms_section">
        <div className="terms_heading">Other Conditions</div>
        <div className="terms_text">
          These conditions will supersede any terms and/or conditions you
          include with any purchase order, regardless of whether this store
          signs them or not. reserves the right to make changes to this site and
          these conditions at any time.
        </div>
      </div>

      <div className="terms_section">
        <div className="terms_heading">Out-of-Stock Products</div>
        <div className="terms_text">
          We will ship your product as it becomes available. Usually, products
          ship by the next business day. However, there may be times when the
          product you have ordered is out-of-stock, which will delay fulfilling
          your order. We will keep you informed of any products that you have
          ordered that are out-of-stock and unavailable for immediate shipment.
          You may cancel your order at any time prior to shipping.
        </div>
      </div>

      <div className="terms_section">
        <div className="terms_heading">Privacy</div>
        <div className="terms_text">
          We keep your personal information private and secure. When you make a
          purchase from , you provide your name, email address, credit card
          information, address, phone number and a password. We use this
          information to process your order(s), to keep you updated on your
          purchases and to personalize your shopping experience. Our secure
          servers protect your information using advanced encryption techniques
          and firewall technology. To keep you informed about our latest offers,
          we may notify you of current promotions, specials and new additions to
          this store. You may unsubscribe from our newsletters by following the
          unsubscribe instructions in any email you receive from us. We use
          "cookies" to keep track of your current shopping session to
          personalize your experience and so that you may retrieve your shopping
          cart at any time.
        </div>
      </div>

      <div className="terms_section">
        <div className="terms_heading">Privacy on other Websites</div>
        <div className="terms_text">
          Other sites accessible through our site have their own privacy
          policies and data collection practices. Please consult each site's
          privacy policy for more information. Verse Medical is not responsible
          for the actions of third parties.
        </div>
      </div>

      <div className="terms_section" id="returns">
        <div className="terms_heading">Returns</div>
        <div className="terms_text">
          We will gladly accept the return of products that are defective due to
          defects in manufacturing and/or workmanship. Fulfillment mistakes that
          may be made which result in the shipment of incorrect products to you
          will also be accepted for return with full refund. Please contact us
          if your MD/OD changes your prescription and you have unused, unopened
          boxes.
          <br /> <br />
          <b>General Guidelines:</b>
          <br /> <br />
          <ul>
            <li>
              Lenses must be returned within 120 days of invoice date and
              accompanied by original invoice.
            </li>
            <li>
              No lenses will be accepted without a minimum of 15 months
              expiration date from the current month.
            </li>
            <li>
              Boxes opened or damaged or marked will not be accepted for return.
            </li>
            <li>
              Boxes damaged in transit will not be a responsibility of Verse
              Medical.
            </li>
            <li>
              Do not send lenses in envelopes - they must be enclosed in a box.
            </li>
            <li>
              Manufacturers retain the right to inspect lenses claimed to be
              defective.
            </li>
          </ul>
          <br />
          <b>
            Special Manufacturer Policies Honored by JetLenses (DBA Verse
            Medical):
          </b>
          <br />
          <br />
          Alcon (800-241-5999); Alcon Platinum Guarantee: full credit for
          returned Dailies or Air Optix brand plus up to $60 credit (from Alcon)
          if the following apply:
          <br />
          <ul>
            <li>Platinum Guarantee form is completely filled out</li>
            <li>Return is accompanied by Verse Medical patient receipt</li>
            <li>The product is not expired.</li>
          </ul>
          Please see the Platinum Guarantee form for more details at
          https://alcon.widen.net/s/a1wq2vcv5g
          <br />
          <br />
          CooperVision (800-341-2020)
          <br />
          Defective lenses must be exchanged within 30 days from the invoice
          date. All defective and any remaining lenses must be returned with a
          copy of the original receipt. Packaging missing end flaps due to
          patient rebate redemption, or any reason, are ineligible for return.
          "100 Day It's OK Guarantee" boxes must have remaining unopened lenses
          returned within 100 days of purchase. 90 pack-85; 30 pack-25; 6pack-5.
          Eligible product for guarantee: Avaira, Biomedics, Biofinity,
          Proclear, Clear Sight and Vertex brands
        </div>
      </div>
    </div>
  );
};

export default Terms;
